"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7096],{

/***/ 85735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ColumnTrack; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/ColumnTrack/ColumnTrack.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var gapSizes = {
  small: 24,
  medium: 32
};

var _ref =  true ? {
  name: "1wg53za",
  styles: "justify-items:center"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kf3he30"
} : 0)("display:grid;width:100%;row-gap:", function (_ref2) {
  var gap = _ref2.gap;
  return gapSizes[gap];
}, "px;column-gap:", function (_ref3) {
  var gap = _ref3.gap;
  return gapSizes[gap];
}, "px;padding:0;grid-template-columns:repeat(", function (_ref4) {
  var columns = _ref4.columns;
  return columns;
}, ", 1fr);", function (_ref5) {
  var center = _ref5.center;
  return center && _ref;
}, " ", function (_ref6) {
  var overridesCss = _ref6.overridesCss;
  return overridesCss;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/ColumnTrack/ColumnTrack.tsx


var _excluded = ["children", "columns", "overrides", "className", "center", "gap", "tag"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var ColumnTrack = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 1 : _ref$columns,
      overrides = _ref.overrides,
      className = _ref.className,
      center = _ref.center,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? "medium" : _ref$gap,
      tag = _ref.tag,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var overridesCss = (0,react.useMemo)(function () {
    var keys = [];

    for (var key in overrides) {
      keys.push(key);
    }

    var overridesCss =
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)( true ? "" : 0,  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);

    if (overrides) {
      overridesCss =
      /*#__PURE__*/

      /*#__PURE__*/
      (0,emotion_react_browser_esm/* css */.iv)(keys === null || keys === void 0 ? void 0 : keys.map(function (key) {
        return (
          /*#__PURE__*/

          /*#__PURE__*/
          (0,emotion_react_browser_esm/* css */.iv)(Theme/* default.breakpoints.up */.ZP.breakpoints.up(key), "{grid-template-columns:repeat(", overrides[key], ", 1fr);}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
        );
      }), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
    }

    return overridesCss;
  }, [overrides]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    center: center,
    ref: ref,
    columns: columns,
    overridesCss: overridesCss,
    overrides: overrides,
    className: className,
    gap: gap,
    as: tag
  }, rest), {}, {
    children: children
  }));
});
;// CONCATENATED MODULE: ../../libs/matcha/components/ColumnTrack/index.ts


/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ })

}]);